import React, { useEffect } from "react";
import "./yoga.css";
// import yogawom from "../../assets/yogawom.png";
import first from "../../assets/firstyoga.jpeg";
import second from "../../assets/secondyoga.png";
import third from "../../assets/3rdyoga.jpeg";
import fourth from "../../assets/4thyoga.jpeg";
import fifth from "../../assets/5thyoga.jpeg";
import sixth from "../../assets/6thyoga.jpeg";
import seventh from "../../assets/7thyoga.jpeg";
import eith from "../../assets/8thyoga.jpeg";
import ninth from "../../assets/9thyoga.png";
import simple from "../../assets/simplewrk.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function YogaMom({ selectedTool, setSelectedTool }) {
  useEffect(() => {
    setSelectedTool("/Pregnancy-yoga");
  }, []);

  return (
    <>
      <div className="yoga-base">
        <Helmet>
          <title>
            Pregnancy Yoga Asanas: Safe for Every Stage of Pregnancy
          </title>
          <meta
            name="description"
            content="Try effective pregnancy yoga asanas that promote your well-being and nourish your body. Experience a healthier, more comfortable pregnancy journey."
          />
          <meta
            name="keywords"
            content="Safe pregnancy yoga, pregnancy yoga, yoga during pregnancy, prenatal yoga"
          />
        </Helmet>

        <div className="yoga-main">
          <div className="bread-container">
            <nav aria-label="breadcrumb">
              <ol className="crumb">
                <li className="breadcrumblist" style={{ fontWeight: "bold" }}>
                  <Link
                    to="/"
                    className="breadcrumb-link"
                    onClick={() => setSelectedTool("")}
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumblist">
                  <Link to="/tools" className="breadcrumb-link">
                    Tools
                  </Link>
                </li>
                <li className="breadcrumblist active">Yoga</li>
              </ol>
            </nav>
          </div>
          <div id="main-yoga-dis">
            <div className="yoga-image">
              <img src={simple} alt="yoga-woman" />
            </div>
            <div className="yoga-cont">
              <h2 className="yoga-heading">Yoga for Moms</h2>
              <h4 className="yoga-subheading">
                First Month to Ninth Month Yoga
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="main2-y">
        <div className="yoga-main2">
          <div className="box-yoga">
            <Link to="yoga-1">
              <img src={first} alt="Yoga_First" />
              <h2>First Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-2">
              <img src={second} alt="Yoga_Second" />
              <h2>Second Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-3">
              <img src={third} alt="Yoga_Third" />
              <h2>Third Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-4">
              <img src={fourth} alt="Yoga_Third" />
              <h2>Fourth Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-5">
              <img src={fifth} alt="Yoga_Third" />
              <h2>Fifth Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-6">
              <img src={sixth} alt="Yoga_Third" />
              <h2>Sixth Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-7">
              <img src={seventh} alt="Yoga_Third" />
              <h2>Seventh Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-8">
              <img src={eith} alt="Yoga_Third" />
              <h2>Eighth Month</h2>
            </Link>
          </div>
          <div className="box-yoga">
            <Link to="yoga-9">
              <img src={ninth} alt="Yoga_Third" />
              <h2>Ninth Month</h2>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default YogaMom;
